<template>
  <div
    v-if="isShow"
    ref="iuOverlay"
    class="frisbuy-iu__overlay"
    :class="{ 'frisbuy-iu--in-drag': inDrag }"
    @click="closePopup"
  >
    <div v-if="settings.custom_style" v-html="settings.custom_style" />

    <GuideButton
      v-if="isGuidlineOpen === true"
      ref="frisbuyGuide"
      @toggle-guide="toggleGuide()"
      :html_guideline_block="settings.html_guideline_block"
    />
    <GuideButton
      v-if="isContentRulesOpen === true"
      @toggle-guide="closeContentRules()"
      :html_guideline_block="settings.html_content_rules_block"
    />

    <div
      ref="iuPopup"
      class="frisbuy-iu__popup"
      :class="{
        'frisbuy-iu__popup--congrats': currentStep === 'congrats',
      }"
      @click.stop
    >
      <template v-if="currentStep !== 'congrats'">
        <div class="frisbuy-iu__header">
          <button class="frisbuy-iu__close" @click="closePopup">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6077 6.29437C17.2138 5.90724 16.5807 5.91272 16.1936 6.3066L11.9878 10.5857L7.70878 6.38003C7.31489 5.9929 6.68175 5.99838 6.29462 6.39227C5.90748 6.78615 5.91296 7.4193 6.30685 7.80643L10.5859 12.0121L6.38006 16.2914C5.99293 16.6852 5.9984 17.3184 6.39229 17.7055C6.78618 18.0926 7.41932 18.0872 7.80645 17.6933L12.0123 13.414L16.2916 17.6199C16.6855 18.0071 17.3186 18.0016 17.7058 17.6077C18.0929 17.2138 18.0874 16.5807 17.6935 16.1935L13.4142 11.9876L17.6199 7.70853C18.0071 7.31465 18.0016 6.6815 17.6077 6.29437Z" fill="#999999"/>
            </svg>

          </button>
        </div>

        <div class="frisbuy-iu__popup-scroll">
        <h3 class="frisbuy-iu__title">
          {{ widgetTitle }}
        </h3>
        <div class="frisbuy-iu__post-form">
          <div v-if="sku" class="frisbuy-iu__sku">
            <img
              class="frisbuy-iu__sku-thumb"
              :src="sku.thumbUrl"
              :alt="sku.name || 'Товар'"
            />
            <span class="frisbuy-iu__sku-name">{{ sku.name }}</span>
          </div>

          <div class="frisbuy-iu__customer-rating">
            <label
              class="frisbuy-iu__stars-title frisbuy-iu__required"
              :class="{
                '--error': formErrors.rating,
              }"
            >
              Поставьте оценку*
            </label>
            <StarRating v-model="rating" @update:modelValue="formErrors.rating = false" />
          </div>

          <div class="frisbuy-iu__customer-review">
            <span class="frisbuy-iu__review-description">
              Ваш комментарий*
            </span>

            <div
              v-if="!showDetailedReview"
              class="frisbuy-iu__review-comment frisbuy-iu__review-comment--with-counter"
              :class="{
                'frisbuy-iu__review-comment--counter-visible': caption.length > 0,
              }"
            >
              <textarea
                v-model="caption"
                class="frisbuy-iu__auto-textarea"
                :class="{
                  'frisbuy-iu__field--error': formErrors.review,
                }"
                rows="1"
                placeholder="Общие впечатления"
                :maxlength="textareaMaxLength"
                @input="
                  onReviewInput();
                  autoResizeTextarea($event);
                "
              ></textarea>
              <div v-if="caption.length > 0" class="frisbuy-iu__textarea-counter">
                {{ caption.length }}/{{ textareaMaxLength }}
              </div>
            </div>
            <div
              v-else
              class="frisbuy-iu__review-comment frisbuy-iu__review-field--with-counter"
              :class="{
                'frisbuy-iu__review-field--counter-visible': caption.length > 0,
              }"
            >
              <textarea
                v-model="caption"
                class="frisbuy-iu__auto-textarea"
                :class="{
                  'frisbuy-iu__field--error': formErrors.review,
                }"
                rows="1"
                placeholder="Общие впечатления"
                :maxlength="textareaMaxLength"
                @input="
                  onReviewInput();
                  autoResizeTextarea($event);
                "
              ></textarea>
              <div v-if="caption.length > 0" class="frisbuy-iu__textarea-counter">
                {{ caption.length }}/{{ textareaMaxLength }}
              </div>
            </div>
            <div
              v-if="showDetailedReview"
              class="frisbuy-iu__review-positive frisbuy-iu__review-field--with-counter"
              :class="{
                'frisbuy-iu__review-field--counter-visible': positiveComment.length > 0,
              }"
            >
              <textarea
                v-model="positiveComment"
                class="frisbuy-iu__auto-textarea"
                :class="{
                  'frisbuy-iu__field--error': formErrors.review,
                }"
                rows="1"
                placeholder="Преимущества"
                :maxlength="textareaMaxLength"
                @input="
                  onReviewInput();
                  autoResizeTextarea($event);
                "
              ></textarea>
              <div v-if="positiveComment.length > 0" class="frisbuy-iu__textarea-counter">
                {{ positiveComment.length }}/{{ textareaMaxLength }}
              </div>
            </div>
            <div
              v-if="showDetailedReview"
              class="frisbuy-iu__review-negative frisbuy-iu__review-field--with-counter"
              :class="{
                'frisbuy-iu__review-field--counter-visible': negativeComment.length > 0,
              }"
            >
              <textarea
                v-model="negativeComment"
                class="frisbuy-iu__auto-textarea"
                :class="{
                  'frisbuy-iu__field--error': formErrors.review,
                }"
                rows="1"
                placeholder="Недостатки"
                :maxlength="textareaMaxLength"
                @input="
                  onReviewInput();
                  autoResizeTextarea($event);
                "
              ></textarea>
              <div v-if="negativeComment.length > 0" class="frisbuy-iu__textarea-counter">
                {{ negativeComment.length }}/{{ textareaMaxLength }}
              </div>
            </div>
            <button
              type="button"
              class="frisbuy-iu__review-toggle"
              @click="showDetailedReview = !showDetailedReview"
            >
              {{
                showDetailedReview
                  ? "Скрыть подробный отзыв"
                  : "Оставить подробный отзыв"
              }}
            </button>

            <div
              v-if="settings.html_guideline_button_text"
              v-html="settings.html_guideline_button_text"
              class="frisbuy-iu__guide-btn"
            ></div>
          </div>
        </div>

        <div class="frisbuy-iu__upload-section">
          <h4 class="frisbuy-iu__upload-title">Загрузите фото или видео</h4>
          <div
            v-if="!limitIsFull && !uploadedFiles.length"
            class="frisbuy-iu__upload"
            @dragover.prevent.stop="inDrag = true"
            @dragleave.prevent.stop="inDrag = false"
            @drop.prevent.stop="uploadFromDrop"
          >
          <button
            class="frisbuy-iu__upload__button"
            :disabled="uploadProcess"
            :class="{ 'frisbuy-iu__upload__button--disabled': uploadProcess }"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25.6237 16.9635V11.75C25.6234 11.2181 25.181 10.7539 24.5938 10.7539C24.4457 10.7539 24.3104 10.7564 24.1758 10.7591C24.0478 10.7617 23.9062 10.7644 23.7747 10.763C23.5562 10.7607 23.1338 10.7526 22.7279 10.5638C22.2011 10.3186 21.9036 9.88239 21.7643 9.43359C21.6504 9.0661 21.6328 8.66444 21.6328 8.32422V7.99349C21.6327 7.27889 21.0396 6.66667 20.2669 6.66667H11.3008C10.5281 6.66667 9.93496 7.27889 9.9349 7.99349V8.32422C9.9349 8.66641 9.91658 9.06979 9.79948 9.4401C9.65616 9.89314 9.35292 10.325 8.82813 10.5664C8.4237 10.7523 8.00412 10.7607 7.78385 10.763C7.65201 10.7644 7.50991 10.7617 7.38151 10.7591C7.2465 10.7564 7.1103 10.7539 6.96224 10.7539C6.37524 10.7542 5.93257 11.2183 5.93229 11.75V21.3385C5.93229 22.9569 7.26875 24.302 8.95833 24.3021H17.2721C18.0084 24.3021 18.6054 24.8991 18.6055 25.6354C18.6055 26.3718 18.0085 26.9688 17.2721 26.9688H8.95833C5.83265 26.9686 3.26562 24.466 3.26562 21.3385V11.75C3.2659 9.70918 4.9391 8.0875 6.96224 8.08724C7.07149 8.08724 7.17455 8.08959 7.26823 8.09115V7.99349C7.26829 5.76974 9.09204 4 11.3008 4H20.2669C22.4757 4 24.2994 5.76974 24.2995 7.99349V8.09115C24.39 8.08967 24.4888 8.08724 24.5938 8.08724C26.6171 8.08724 28.2901 9.70902 28.2904 11.75V16.9635C28.2904 17.6999 27.6934 18.2969 26.957 18.2969C26.2209 18.2966 25.6237 17.6997 25.6237 16.9635Z"
                fill="#999999"
              />
              <path
                d="M18.0936 16.0008C18.0936 14.8535 17.1499 13.9086 16.0024 13.9083C14.8548 13.9083 13.91 14.8533 13.91 16.0008C13.9103 17.148 14.855 18.0919 16.0024 18.0919C17.1497 18.0917 18.0933 17.1479 18.0936 16.0008ZM20.7603 16.0008C20.76 18.6207 18.6224 20.7584 16.0024 20.7586C13.3823 20.7586 11.2436 18.6209 11.2433 16.0008C11.2433 13.3805 13.3822 11.2417 16.0024 11.2417C18.6225 11.2419 20.7603 13.3806 20.7603 16.0008Z"
                fill="#999999"
              />
              <path
                d="M27.4049 22.5424L27.5404 22.5489C28.213 22.6169 28.7383 23.1852 28.7383 23.8758C28.7383 24.5663 28.213 25.1346 27.5404 25.2026L27.4049 25.2091H26.001V26.6667C26.001 27.4031 25.404 28.0001 24.6677 28.0001C23.9313 28.0001 23.3343 27.4031 23.3343 26.6667V25.2091H21.9284C21.192 25.2091 20.5951 24.6121 20.5951 23.8758C20.5951 23.1394 21.192 22.5424 21.9284 22.5424H23.3343V21.2149C23.3343 20.4785 23.9313 19.8816 24.6677 19.8816C25.404 19.8816 26.001 20.4785 26.001 21.2149V22.5424H27.4049Z"
                fill="#999999"
              />
            </svg>

            <div class="frisbuy-iu__upload__wrapper">
              <span class="frisbuy-iu__upload__text-title">Добавить фото и видео</span>
              <span class="frisbuy-iu__upload__text">Добавить фото и видео</span>
            </div>

            <input
              title="Добавить Фото"
              type="file"
              multiple
              accept="image/png, image/jpeg, video/mp4, video/quicktime"
              @change="uploadFromInput"
            />
          </button>
          <div
            v-if="inDrag"
            class="frisbuy-iu__drop-area"
            :class="{
              'frisbuy-iu__drop-area--limited': limitIsFull || uploadProcess,
            }"
          >
            <svg
              width="134"
              height="134"
              viewBox="0 0 134 134"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M67 122.834C97.8359 122.834 122.833 97.8362 122.833 67.0003C122.833 36.1644 97.8359 11.167 67 11.167C36.1641 11.167 11.1667 36.1644 11.1667 67.0003C11.1667 97.8362 36.1641 122.834 67 122.834Z"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M67 39.083L67 94.9163"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M39.0833 67L94.9166 67"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          </div>
        </div>
        <div v-if="uploadedFiles.length || isMobileViewport" class="frisbuy-iu__preview">
          <div class="frisbuy-iu__media-list">
            <div
              v-for="(media, index) in uploadedFiles"
              :key="media.id"
              class="frisbuy-iu__media-item"
            >
              <img
                ref="uploadedImages"
                :src="media.url"
                class="frisbuy-iu__media-image"
                @error="reloadImage(index, media.url)"
              />
              <div
                v-if="media.__isVideo || /\.(mp4|mov)(\?|$)/i.test(media.url)"
                class="frisbuy-iu__media-video-icon"
              >
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.9748 13.7289C24.6669 14.7701 24.6669 17.2297 22.9748 18.271L13.3963 24.1655C11.6196 25.2589 9.33203 23.9806 9.33203 21.8944L9.33203 10.1054C9.33203 8.01926 11.6196 6.74099 13.3963 7.83436L22.9748 13.7289Z" fill="white"/>
                </svg>
              </div>
              <div
                class="frisbuy-iu__media-close"
                @click="uploadedFiles.splice(index, 1)"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="11.5" fill="#212121" stroke="white" />
                  <path
                    d="M14.7998 8.19922C15.0582 7.93666 15.4803 7.93332 15.7432 8.19141C16.0061 8.44982 16.0104 8.87282 15.752 9.13574L12.9443 11.9912L15.8008 14.7988C16.0637 15.0572 16.0669 15.4802 15.8086 15.7432C15.5502 16.0061 15.1272 16.0094 14.8643 15.751L12.0078 12.9443L9.20117 15.8008C8.94274 16.0635 8.51971 16.067 8.25684 15.8086C7.99404 15.5502 7.99065 15.1271 8.24902 14.8643L11.0557 12.0078L8.19922 9.20117C7.93631 8.94276 7.93302 8.51976 8.19141 8.25684C8.44982 7.99391 8.87282 7.99061 9.13574 8.24902L11.9912 11.0557L14.7998 8.19922Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>
            <button
              v-if="(uploadedFiles.length || isMobileViewport) && !limitIsFull"
              class="frisbuy-iu__media-add-tile"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.2178 12.7227V8.8125C19.2176 8.41361 18.8857 8.06543 18.4453 8.06543C18.3343 8.06543 18.2328 8.06731 18.1318 8.06934C18.0358 8.07126 17.9296 8.07332 17.8311 8.07227C17.6672 8.07051 17.3503 8.06447 17.0459 7.92285C16.6508 7.73892 16.4277 7.41179 16.3232 7.0752C16.2378 6.79957 16.2246 6.49833 16.2246 6.24316V5.99512C16.2246 5.45916 15.7797 5 15.2002 5H8.47559C7.89611 5 7.45122 5.45917 7.45117 5.99512V6.24316C7.45117 6.49981 7.43743 6.80234 7.34961 7.08008C7.24212 7.41986 7.01469 7.74378 6.62109 7.9248C6.31778 8.06422 6.00309 8.0705 5.83789 8.07227C5.73901 8.07332 5.63243 8.07126 5.53613 8.06934C5.43488 8.06731 5.33273 8.06543 5.22168 8.06543C4.78143 8.06563 4.44943 8.41372 4.44922 8.8125V16.0039C4.44922 17.2177 5.45156 18.2265 6.71875 18.2266H12.9541C13.5063 18.2266 13.954 18.6743 13.9541 19.2266C13.9541 19.7788 13.5064 20.2266 12.9541 20.2266H6.71875C4.37449 20.2265 2.44922 18.3495 2.44922 16.0039V8.8125C2.44943 7.28188 3.70433 6.06563 5.22168 6.06543C5.30362 6.06543 5.38091 6.06719 5.45117 6.06836V5.99512C5.45122 4.3273 6.81903 3 8.47559 3H15.2002C16.8568 3 18.2246 4.32731 18.2246 5.99512V6.06836C18.2925 6.06726 18.3666 6.06543 18.4453 6.06543C19.9628 6.06543 21.2176 7.28176 21.2178 8.8125V12.7227C21.2178 13.2749 20.7701 13.7227 20.2178 13.7227C19.6657 13.7224 19.2178 13.2748 19.2178 12.7227Z" fill="currentColor"/>
                <path d="M13.5702 12.0006C13.5702 11.1401 12.8624 10.4314 12.0018 10.4313C11.1411 10.4313 10.4325 11.14 10.4325 12.0006C10.4327 12.861 11.1412 13.569 12.0018 13.569C12.8623 13.5688 13.57 12.8609 13.5702 12.0006ZM15.5702 12.0006C15.57 13.9655 13.9668 15.5688 12.0018 15.569C10.0368 15.569 8.43272 13.9656 8.4325 12.0006C8.4325 10.0354 10.0366 8.43126 12.0018 8.43126C13.9669 8.43142 15.5702 10.0355 15.5702 12.0006Z" fill="currentColor"/>
                <path d="M20.5537 16.9068L20.6553 16.9117C21.1597 16.9627 21.5537 17.3889 21.5537 17.9068C21.5537 18.4247 21.1597 18.8509 20.6553 18.9019L20.5537 18.9068H19.5007V20.0001C19.5007 20.5523 19.053 21.0001 18.5007 21.0001C17.9485 21.0001 17.5007 20.5523 17.5007 20.0001V18.9068H16.4463C15.894 18.9068 15.4463 18.4591 15.4463 17.9068C15.4463 17.3545 15.894 16.9068 16.4463 16.9068H17.5007V15.9112C17.5007 15.3589 17.9485 14.9112 18.5007 14.9112C19.053 14.9112 19.5007 15.3589 19.5007 15.9112V16.9068H20.5537Z" fill="currentColor"/>
              </svg>
              <input
                title="Добавить Фото"
                type="file"
                multiple
                accept="image/png, image/jpeg, video/mp4, video/quicktime"
                @change="uploadFromInput"
              />
            </button>
          </div>
        </div>
        <div v-if="mediaError" class="frisbuy-iu__field-error frisbuy-iu__media-error">
          Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV
        </div>

        <div class="frisbuy-iu__person-info">
          <span class="frisbuy-iu__person-title">Ваши данные*</span>
          <div class="frisbuy-iu__input-form">
            <div
              class="frisbuy-iu__input-with-status"
              :class="{
                'frisbuy-iu__input-with-status--filled': username.trim().length > 0,
              }"
            >
            <input
              class="frisbuy-iu__input-name"
              :class="{
                'frisbuy-iu__field--error': formErrors.name,
              }"
              v-model="username"
              type="text"
              @input="onNameInput"
              placeholder="Имя"
            />
              <div
                v-if="username.trim().length > 0"
                class="frisbuy-iu__input-status-icon"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.4863 10.7071C16.8768 10.3166 16.8768 9.68342 16.4863 9.29289C16.0957 8.90237 15.4626 8.90237 15.072 9.29289L10.8289 13.536L8.70711 11.4143C8.31658 11.0237 7.68342 11.0237 7.29289 11.4143C6.90237 11.8048 6.90237 12.4379 7.29289 12.8285L10.1213 15.6569C10.3297 15.8653 10.6071 15.9624 10.8799 15.9485C11.1187 15.9365 11.3541 15.8393 11.5365 15.6569L16.4863 10.7071Z" fill="#99CC33"/>
                </svg>
              </div>
            </div>
            <span v-if="formErrors.name" class="frisbuy-iu__field-error">
              Введите ваше имя
            </span>
          </div>

          <div v-if="!settings.logged_in_email" class="frisbuy-iu__input-form">
            <div
              class="frisbuy-iu__input-with-status"
              :class="{
                'frisbuy-iu__input-with-status--filled':
                  email.trim().length > 0 && !formErrors.contact,
              }"
            >
            <input
              class="frisbuy-iu__input-email"
              :class="{
                'frisbuy-iu__field--error': formErrors.contact,
              }"
              v-model="email"
              type="text"
              @input="onContactInput"
              placeholder="e-mail"
            />
              <div
                v-if="email.trim().length > 0 && !formErrors.contact"
                class="frisbuy-iu__input-status-icon"
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.4863 10.7071C16.8768 10.3166 16.8768 9.68342 16.4863 9.29289C16.0957 8.90237 15.4626 8.90237 15.072 9.29289L10.8289 13.536L8.70711 11.4143C8.31658 11.0237 7.68342 11.0237 7.29289 11.4143C6.90237 11.8048 6.90237 12.4379 7.29289 12.8285L10.1213 15.6569C10.3297 15.8653 10.6071 15.9624 10.8799 15.9485C11.1187 15.9365 11.3541 15.8393 11.5365 15.6569L16.4863 10.7071Z" fill="#99CC33"/>
                </svg>
              </div>
            </div>
            <p v-if="!email.trim().length" class="frisbuy-iu__email-note">
              Контакты нужны для связи с вами и нигде не публикуются
            </p>
            <span v-if="formErrors.contact" class="frisbuy-iu__field-error">
              {{ !email.trim().length ? "Введите ваш e-mail" : "Ведены некорретные контактные данные" }}
            </span>
          </div>
          <p class="frisbuy-iu__person-note">
            *Все отзывы проходят модерацию. Если вы столкнулись с неудовлетворительным качеством заказа, укажите ваш номер телефона в поле “комментарий". А чтобы попасть в галерею на сайте Askona, ознакомьтесь с гайдом по фото и видео.
          </p>
        </div>

        <div class="frisbuy-iu__controls">
          <div class="frisbuy-iu__checkboxes">
            <label class="frisbuy-iu__checkbox">
              <input
                v-model="agreedWithRules"
                type="checkbox"
                @change="formErrors.consent = false"
              />
              <div
                class="frisbuy-iu__checkbox__toggle"
                :class="{
                  'frisbuy-iu__checkbox__toggle--checked': agreedWithRules,
                }"
              >
                <svg
                  class="frisbuy-iu__checkbox-icon frisbuy-iu__checkbox-icon--off"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="1"
                    stroke="#BBBBBB"
                    stroke-width="2"
                  />
                </svg>
                <svg
                  class="frisbuy-iu__checkbox-icon frisbuy-iu__checkbox-icon--on"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" fill="#00B9BF" />
                  <path
                    d="M16.4863 10.7071C16.8768 10.3166 16.8768 9.68342 16.4863 9.29289C16.0957 8.90237 15.4626 8.90237 15.072 9.29289L10.8289 13.536L8.70711 11.4143C8.31658 11.0237 7.68342 11.0237 7.29289 11.4143C6.90237 11.8048 6.90237 12.4379 7.29289 12.8285L10.1213 15.6569C10.3297 15.8653 10.6071 15.9624 10.8799 15.9485C11.1187 15.9365 11.3541 15.8393 11.5365 15.6569L16.4863 10.7071Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div
                v-if="settings.personal_data_agreement_content"
                class="frisbuy-iu__checkbox__label"
                v-html="settings.personal_data_agreement_content"
              ></div>
              <div v-else class="frisbuy-iu__checkbox__label">
                Я ознакомился и согласен с
                <a
                  :href="settings.link_personal_data_agreement"
                  target="_blank"
                >
                  правилами магазина
                </a>
              </div>
            </label>
            <span v-if="formErrors.consent" class="frisbuy-iu__field-error">
              Необходимо ваше согласие
            </span>

            <label
              v-if="settings['show_subscription'] === '1'"
              class="frisbuy-iu__checkbox frisbuy-iu__checkbox--subscription"
            >
              <input v-model="subscribtionCheckbox" type="checkbox" />
              <div
                class="frisbuy-iu__checkbox__toggle"
                :class="{
                  'frisbuy-iu__checkbox__toggle--checked': subscribtionCheckbox,
                }"
              >
                <svg
                  class="frisbuy-iu__checkbox-icon frisbuy-iu__checkbox-icon--off"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="4"
                    y="4"
                    width="16"
                    height="16"
                    rx="1"
                    stroke="#BBBBBB"
                    stroke-width="2"
                  />
                </svg>
                <svg
                  class="frisbuy-iu__checkbox-icon frisbuy-iu__checkbox-icon--on"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="3" y="3" width="18" height="18" rx="2" fill="#00B9BF" />
                  <path
                    d="M16.4863 10.7071C16.8768 10.3166 16.8768 9.68342 16.4863 9.29289C16.0957 8.90237 15.4626 8.90237 15.072 9.29289L10.8289 13.536L8.70711 11.4143C8.31658 11.0237 7.68342 11.0237 7.29289 11.4143C6.90237 11.8048 6.90237 12.4379 7.29289 12.8285L10.1213 15.6569C10.3297 15.8653 10.6071 15.9624 10.8799 15.9485C11.1187 15.9365 11.3541 15.8393 11.5365 15.6569L16.4863 10.7071Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div
                v-html="subscriptionText"
                class="frisbuy-iu__checkbox__label"
              ></div>
            </label>
          </div>

          <button
            class="frisbuy-iu__submit"
            :class="{
              'frisbuy-iu__submit--disabled': uploadProcess,
            }"
            @click="saveAsPost"
          >
            Отправить
          </button>
        </div>
        <div class="frisbuy-iu__submit-mobile-wrap">
          <button
            class="frisbuy-iu__submit frisbuy-iu__submit--mobile"
            :class="{
              'frisbuy-iu__submit--disabled': uploadProcess,
            }"
            @click="saveAsPost"
          >
            Отправить
          </button>
        </div>
        </div>
      </template>
      <template v-else>
        <div class="frisbuy-iu__message frisbuy-iu__message-congrats">
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11ZM11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0ZM15.9069 9.00691C16.2974 8.61639 16.2974 7.98322 15.9069 7.5927C15.5164 7.20217 14.8832 7.20217 14.4927 7.5927L9.7998 12.2856L7.50691 9.9927C7.11639 9.60217 6.48322 9.60217 6.0927 9.9927C5.70217 10.3832 5.70217 11.0164 6.0927 11.4069L9.0927 14.4069C9.48322 14.7974 10.1164 14.7974 10.5069 14.4069L15.9069 9.00691Z"
              fill="#2C2C2C"
            />
          </svg>
          <span>
            Отзыв успешно отправлен на модерацию.
            <span>Вы получите уведомление на почту.</span>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// Modules
import axios from "axios";
// Mixins
import analytics from "../../common/mixins/analytics";
// Components
import StarRating from "./components/StarRating.vue";
import GuideButton from "../letoile_official/GuideButton.vue";
// Services
import { DomainSubstitute } from "@/common/services/DomainSubstitute/DomainSubstitute";
import { redirectToAuthPage } from "../services";

export default {
  mixins: [analytics],

  // NOTE: StarRating uses as hot-fix. See "NOTE" into the component
  components: { StarRating, GuideButton },

  props: ["propSettings", "sku"],
  data() {
    // TODO: Refactor next line
    const { logged_in_email, logged_in_id, logged_in_name } = this.propSettings;
    console.log(this.propSettings)

    return {
      settings: this.propSettings || {},
      maxLimit: 10,
      isShow: true,
      currentStep: "upload",
      filesToUpload: null,
      filesProcessed: 0,
      uploadedFiles: [],
      uploadProcess: false,
      error: null,
      username: logged_in_name || logged_in_id || "",
      email: logged_in_email || "",
      rating: 0,
      positiveComment: "",
      negativeComment: "",
      caption: "",
      agreedWithRules: false,
      inDrag: false,
      labelItemPosition: ["url", "friPostId", "uploadPhotoCount"],
      categoryPostfix: "IUpload",
      isGuidlineOpen: false,
      isContentRulesOpen: false,
      isVideoCompression: false,
      isMobileViewport: false,
      mediaError: "",
      formErrors: {
        review: false,
        name: false,
        consent: false,
        rating: false,
        contact: false,
      },

      subscribtionCheckbox: false,
      showDetailedReview: false,
      subscriptionText:
        this.propSettings["subscription_text"] || "Подписаться на рассылку",

      textareaMaxLength: 100,
    };
  },

  mounted() {
    document.addEventListener("frisbuy:iu-open", this.showPopup);
    this.updateViewportFlags();
    window.addEventListener("resize", this.updateViewportFlags);
    this.$nextTick(() => {
      const textareas = this.$el.querySelectorAll(".frisbuy-iu__auto-textarea");
      textareas.forEach((textarea) => this.autoResizeTextarea({ target: textarea }));
    });

    // #region sonata's scripts
    window.frisbuy.sonata = {
      openGuide: this.openGuide,
      openContentRules: this.openContentRules,
    };
    // #endregion sonata's scripts
  },
  beforeUnmount() {
    document.removeEventListener("frisbuy:iu-open", this.showPopup);
    window.removeEventListener("resize", this.updateViewportFlags);
  },

  computed: {
    limitIsFull() {
      const { uploadedFiles, maxLimit } = this;

      return uploadedFiles.length >= maxLimit;
    },

    trackingSkuId: function () {
      const { skuId, groupId, categoryId } = this.settings;

      return (
        (skuId && `_sku${skuId}`) ||
        (groupId && `_skug${groupId}`) ||
        (categoryId && `_cat${categoryId}`) ||
        ""
      );
    },

    widgetTitle() {
      return this.sku && this.sku.hasReviews
        ? "Написать отзыв"
        : "Станьте первым, оставьте свой отзыв о товаре";
    },

    isUserLoggedIn() {
      const { logged_in_id, logged_in_email, logged_in_phone } = this.settings;

      return !!logged_in_id && !!logged_in_email && !!logged_in_phone;
    },
  },

  watch: {
    currentStep(newStepName, oldStepName) {
      if (newStepName === "post") {
        this.sendAnalyticEvent("UplphotoUploaded", {
          link: location.href,
          linklabel: document.title,
        });
      }

      if (oldStepName === "upload") return;

      this.error = null;
    },

    isShow: {
      handler(value) {
        const { logged_in_email, logged_in_id } = this.settings;

        if (value) {
          this.sendAnalyticEvent("UplphotoOpen");

          if (this.settings.auth_page_url && !this.isUserLoggedIn) {
            const backUrl = window.location.href;
            redirectToAuthPage(this.settings.auth_page_url, backUrl);

            this.closePopup();
            return;
          }

          this.$nextTick(() => {
            const { $el } = this;

            document.body.appendChild($el);

            this.lockWindowScroll();
          });

          return;
        }

        this.unlockWindowScroll();

        this.currentStep = "upload";
        this.filesToUpload = null;
        this.filesProcessed = 0;
        this.uploadedFiles = [];
        this.uploadProcess = false;
        this.error = null;
        this.mediaError = "";
        this.username = this.username || logged_in_id || "";
        this.email = this.email || logged_in_email || "";
        this.agreedWithRules = false;
        this.showDetailedReview = false;
        this.resetFormErrors();
      },

      immediate: true,
    },

    showDetailedReview() {
      this.$nextTick(() => {
        const textareas = this.$el.querySelectorAll(".frisbuy-iu__auto-textarea");
        textareas.forEach((textarea) => this.autoResizeTextarea({ target: textarea }));
      });
    },
  },

  methods: {
    lockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "hidden";
    },

    unlockWindowScroll() {
      const customScrollElement = this.settings.scrollElement;
      const scrollElement = customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "";
    },

    updateViewportFlags() {
      this.isMobileViewport = window.innerWidth <= 1023;
    },

    showPopup() {
      this.isShow = true;
    },

    closePopup() {
      this.toggleGuide();
      this.closeContentRules();

      this.isShow = false;
      this.subscribtionCheckbox = false;
      this.mediaError = "";
      this.resetFormErrors();
    },

    clearForm() {
      this.email = "";
      this.username = "";
      this.logged_in_id = "";
      this.rating = 0;
      this.positiveComment = "";
      this.negativeComment = "";
      this.caption = "";
    },

    componentAction({ action }) {
      const { settings, trackingSkuId } = this;

      return `${action}_embedID${settings.embedId + trackingSkuId}`;
    },

    uploadFromDrop(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.dataTransfer;

      this.inDrag = false;

      if (limitIsFull || uploadProcess) return;

      const availableSlots = maxLimit - uploadedFiles.length;
      const selectedFiles = [...files].slice(0, availableSlots);
      if (files.length > availableSlots) {
        this.mediaError =
          "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";
      }
      this.filesToUpload = this.filterValidMediaFiles(selectedFiles);

      if (!this.filesToUpload.length) return;

      uploadFiles();
    },

    uploadFromInput(event) {
      const {
        uploadFiles,
        uploadedFiles,
        maxLimit,
        limitIsFull,
        uploadProcess,
      } = this;
      const { files } = event.target;

      if (limitIsFull || uploadProcess) return;

      const availableSlots = maxLimit - uploadedFiles.length;
      const selectedFiles = [...files].slice(0, availableSlots);
      if (files.length > availableSlots) {
        this.mediaError =
          "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";
      }
      this.filesToUpload = this.filterValidMediaFiles(selectedFiles);

      if (!this.filesToUpload.length) return;

      uploadFiles();
    },

    filterValidMediaFiles(files) {
      const allowedTypes = ["image/png", "image/jpeg", "video/mp4", "video/quicktime"];
      const maxFileSize = 10 * 1024 * 1024;

      const validFiles = files.filter((file) => {
        const isValidType = allowedTypes.includes(file.type);
        const isValidSize = file.size <= maxFileSize;
        return isValidType && isValidSize;
      });

      if (validFiles.length !== files.length) {
        this.mediaError =
          "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";
      } else {
        this.mediaError = "";
      }

      return validFiles;
    },

    uploadFiles() {
      const { filesToUpload, settings } = this;
      const { srcDomain, embedId } = settings;

      this.uploadProcess = true;
      this.filesProcessed = 0;
      this.error = null;
      this.mediaError = "";

      filesToUpload.forEach((file) => {
        const formData = new FormData();

        formData.append("file", file, file.name);

        if (file.size > 10 * 1024 * 1024) {
          this.filesProcessed += 1;
          this.mediaError =
            "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";

          if (this.filesProcessed !== filesToUpload.length) return;

          this.uploadProcess = false;
          this.filesToUpload = [];
          this.currentStep = "preview";

          return;
        }

        axios({
          url: DomainSubstitute(`${srcDomain}/api/1.0.0/customer/medias?embed_id=${embedId}`),
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progress) => {
            const isUploaded = progress.total === progress.loaded;

            if (isUploaded) {
              this.isVideoCompression = true;
            }
          },
        })
          .then(({ data }) => {
            const { request, response } = data;
            const { success, statusMessage } = request;
            const { post_media } = response.body;

            if (!success) {
              this.mediaError =
                statusMessage ||
                "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";
              return;
            }

            this.uploadedFiles.push({
              ...post_media,
              __isVideo: file.type.startsWith("video/"),
            });
          })
          .catch((error) => {
            const { response } = error;

            this.sendAnalyticEvent("UplphotoError", {
              link: location.href,
              linklabel: document.title,
              error: this.error,
            });

            if (!response || typeof response.data.request === "string") {
              if (error && response && response.status === 413) {
                this.mediaError =
                  "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";
                return;
              }

              this.mediaError =
                "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";
              return;
            }

            this.mediaError =
              "Файл превышает 10 Мб или не подходит по формату. Загрузка до 10 файлов в формате PNG, JPEG, MP4, MOV";
          })
          .finally(() => {
            this.filesProcessed += 1;

            if (this.filesProcessed !== filesToUpload.length) return;

            this.uploadProcess = false;
            this.isVideoCompression = false;
            this.filesToUpload = [];
            this.currentStep = "preview";
          });
      });
    },

    saveAsPost() {
      let {
        uploadedFiles,
        username,
        email,
        rating,
        positiveComment,
        negativeComment,
        caption,
        agreedWithRules,
        settings,
      } = this;
      const { srcDomain, embedId, logged_in_id } = settings;
      username = username.trim();
      email = email.trim();
      this.error = null;
      this.resetFormErrors();

      if (!rating) this.formErrors.rating = true;
      if (!username) this.formErrors.name = true;
      const shouldShowContactField = !settings.logged_in_email;
      const contactValue = shouldShowContactField
        ? email
        : (settings.logged_in_email || "").trim();
      const contactPayload = this.getContactPayload(contactValue);
      this.formErrors.contact = shouldShowContactField
        ? !contactValue || !this.isContactValid(contactValue)
        : false;
      if (!positiveComment.trim() && !negativeComment.trim() && !caption.trim()) {
        this.formErrors.review = true;
      }
      if (!agreedWithRules) this.formErrors.consent = true;

      if (
        this.formErrors.rating ||
        this.formErrors.name ||
        this.formErrors.contact ||
        this.formErrors.review ||
        this.formErrors.consent
      ) {
        return;
      }

      let url = `${srcDomain}/api/1.0.0/customer/reviews?embed_id=${embedId}`;

      if (this.settings.groupId) {
        url = url + `&group=${this.settings.groupId}`;
      }

      const requestData = {
        post_medias: uploadedFiles,
        username,
        logged_in_id,
        rating,
        positiveComment,
        negativeComment,
        caption,
        url: encodeURIComponent(location.href),
      };

      if (contactPayload) {
        Object.assign(requestData, contactPayload);
      }

      axios({
        url: DomainSubstitute(url),
        method: "POST",
        data: requestData,
      })
        .then(({ data }) => {
          const { success, statusMessage } = data.request;

          if (!success) {
            this.error = statusMessage;
            return;
          }

          if (
            this.settings["show_subscription"] &&
            this.subscribtionCheckbox &&
            contactPayload &&
            contactPayload.email
          ) {
            this.makeEventForClient("subscribe-on-newsletter", {
              email: contactPayload.email,
            });
          }

          this.sendAnalyticEvent("UplphotoOK", {
            url: location.href,
            uploadPhotoCount: uploadedFiles.length,
            link: location.href,
            linklabel: document.title,
          });

          this.currentStep = "congrats";
          this.clearForm();

          setTimeout(() => {
            this.closePopup();
          }, 3000);
        })
        .catch((error) => {
          const { response } = error;

          this.sendAnalyticEvent("UplphotoError", {
            link: location.href,
            linklabel: document.title,
            error: this.error,
          });

          if (response) {
            const { data } = response;

            this.error = data.request.error;
          } else {
            this.error = "Ошибка на сервере, попробуйте позже";
          }
        });
    },

    makeEventForClient(eventName, data, eventNamePrefix = "frisbuy") {
      const resultEventName = `${eventNamePrefix}:${eventName}`;

      document.dispatchEvent(
        new CustomEvent(resultEventName, { detail: data })
      );
    },

    resetFormErrors() {
      this.formErrors = {
        review: false,
        name: false,
        consent: false,
        rating: false,
        contact: false,
      };
    },

    onReviewInput() {
      this.formErrors.review = false;
      this.error = null;
    },

    autoResizeTextarea(event) {
      const textarea = event && event.target;
      if (!textarea) {
        return;
      }

      textarea.style.height = "40px";
      textarea.style.height = `${Math.max(textarea.scrollHeight, 40)}px`;
    },

    onNameInput() {
      this.formErrors.name = false;
      this.error = null;
    },

    onContactInput() {
      this.formErrors.contact = false;
      this.error = null;
    },

    getContactPayload(contactValue) {
      if (!contactValue) {
        return {};
      }

      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(contactValue);

      if (isEmail) {
        return { email: contactValue };
      }

      return null;
    },

    isContactValid(contactValue) {
      return this.getContactPayload(contactValue) !== null;
    },

    reloadImage(index, url) {
      /*
        NOTE: Backend cache return 404 error.
        To update cache I use random query param
      */
      const randomValue = Math.random().toString().slice(2);
      const randomQueryParam = `random_query_param=${randomValue}`;

      const fixedUrl = `${url}?recovery=true&${randomQueryParam}`;
      this.$refs.uploadedImages[index].src = fixedUrl;
    },

    toggleGuide() {
      this.isGuidlineOpen = false;

      if (!this.isGuideFromIU) {
        this.isShow = false;
      } else {
        this.isGuideFromIU = false;
      }
    },
    openGuide() {
      if (!this.settings.html_guideline_block) {
        return;
      }

      this.isGuideFromIU = true;
      this.isGuidlineOpen = true;
    },

    closeContentRules() {
      this.isContentRulesOpen = false;
    },
    openContentRules() {
      if (!this.settings.html_content_rules_block) {
        return;
      }

      this.isContentRulesOpen = true;
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

body[widget-iu-loaded] {
  *[widget-iu-button] {
    visibility: visible !important;
    pointer-events: all !important;
  }
}

.frisbuy-iu__overlay {
  position: fixed;
  inset: 0;
  z-index: 99999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px;
  background: rgba(95, 107, 119, 0.45);
  font-family: Gilroy, "Segoe UI", Arial, sans-serif;
  color: #2b2d33;
}

.frisbuy-iu__popup {
  position: relative;
  width: min(100%, 520px);
  max-height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 6px;
}

.frisbuy-iu__popup--congrats {
  padding: 16px;
  align-items: center;
  justify-content: center;
}

.frisbuy-iu__popup--congrats .frisbuy-iu__message {
  margin-top: 0;
}

.frisbuy-iu__header {
  position: relative;
  width: 100%;
  flex: 0 0 40px;
  height: 40px;
  z-index: 3;
  background: #fff;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.frisbuy-iu__title {
  margin: 0;
  color: #212121;
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  padding-right: 48px;
}

.frisbuy-iu__close {
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 40px;
  border: 0;
  padding: 8px;
  background: transparent;
  cursor: pointer;
  z-index: 3;

  svg {
    width: 100%;
    height: 100%;
  }
}

.frisbuy-iu__popup-scroll {
  overflow-y: auto;
  min-height: 0;
  padding: 0 40px 40px;
}

.frisbuy-iu__post-form,
.frisbuy-iu__preview,
.frisbuy-iu__person-info,
.frisbuy-iu__message,
.frisbuy-iu__controls {
  margin-top: 16px;
}

.frisbuy-iu__upload-section {
  margin-top: 24px;
}

.frisbuy-iu__upload-title {
  margin: 0;
  color: #212121;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}

.frisbuy-iu__upload {
  margin-top: 16px;
}


.frisbuy-iu__review-description {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #212121;
}

.frisbuy-iu__required.--error {
  color: rgba(254, 0, 102, 1);
}

.frisbuy-iu__customer-review {
  margin-top: 24px;
}

.frisbuy-iu__customer-rating {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.frisbuy-iu__sku {
  margin-top: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.frisbuy-iu__sku-thumb {
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  object-fit: contain;
}

.frisbuy-iu__sku-name {
  color: rgba(33, 33, 33, 1);
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.frisbuy-iu__review-positive,
.frisbuy-iu__review-negative,
.frisbuy-iu__review-comment,
.frisbuy-iu__input-form {
  margin-top: 12px;
}

.frisbuy-iu__customer-review > .frisbuy-iu__review-comment {
  margin-top: 16px;
}

.frisbuy-iu__review-toggle {
  margin-top: 12px;
  border: 0;
  padding: 0;
  background: transparent;
  color: #212121;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  text-decoration-line: underline;
  text-decoration-style: dashed;
  text-decoration-thickness: 1px;
  text-underline-offset: 2px;
  font-family: Gilroy, "Segoe UI", Arial, sans-serif;
  cursor: pointer;

  &:hover {
    color: rgba(0, 159, 164, 1);
  }
}

.frisbuy-iu__popup textarea,
.frisbuy-iu__popup input[type="text"] {
  box-sizing: border-box;
  width: 100%;
  border: 0;
  border-radius: 40px;
  background: #f6f6f6;
  color: rgba(33, 33, 33, 1);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  font-family: inherit;
  padding: 12px 16px;
  outline: none;
}

.frisbuy-iu__popup textarea {
  display: block;
  min-height: 40px;
  height: 40px;
  resize: none;
  overflow: hidden;
  border-radius: 8px;
  padding: 8px 16px;
}

.frisbuy-iu__popup textarea::placeholder {
  color: #999999;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-transform: none;
}

.frisbuy-iu__popup input[type="text"]::placeholder {
  text-transform: none;
}

.frisbuy-iu__review-comment--with-counter {
  position: relative;
}

.frisbuy-iu__review-comment--counter-visible textarea {
  padding-bottom: 32px;
}

.frisbuy-iu__review-field--with-counter {
  position: relative;
}

.frisbuy-iu__review-field--counter-visible textarea {
  padding-bottom: 32px;
}

.frisbuy-iu__textarea-counter {
  position: absolute;
  right: 8px;
  bottom: 8.5px;
  text-align: right;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  color: #999999;
  pointer-events: none;
}

.frisbuy-iu__upload__wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  font-size: 12px;
  line-height: 16px;
}

.frisbuy-iu__upload__text-title {
  font-weight: 700;
  font-family: Gilroy, "Segoe UI", Arial, sans-serif;
}

.frisbuy-iu__upload__text {
  font-weight: 400;
  font-family: Gilroy, "Segoe UI", Arial, sans-serif;
}

.frisbuy-iu__field--error {
  background: rgba(253, 240, 245, 1) !important;
}

.frisbuy-iu__field--error::placeholder {
  color: rgba(33, 33, 33, 1) !important;
}

.frisbuy-iu__input-name,
.frisbuy-iu__input-email {
  height: 40px;
  padding: 8px 16px;
  border-radius: 40px;
}

.frisbuy-iu__input-with-status {
  position: relative;
}

.frisbuy-iu__input-with-status .frisbuy-iu__input-name,
.frisbuy-iu__input-with-status .frisbuy-iu__input-email {
  padding-right: 44px;
}

.frisbuy-iu__input-with-status--filled .frisbuy-iu__input-name,
.frisbuy-iu__input-with-status--filled .frisbuy-iu__input-email {
  background: #f0f6e3 !important;
  color: #212121 !important;
}

.frisbuy-iu__input-status-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  width: 24px;
  height: 24px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.frisbuy-iu__person-note {
  margin: 24px 0 0;
  color: #666666;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

.frisbuy-iu__email-note {
  margin: 4px 0 0;
  color: #666666;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
}

.frisbuy-iu__upload__button {
  position: relative;
  width: 100%;
  min-height: 97px;
  border: 0;
  border-radius: 8px;
  background: #f6f6f6;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #666666;
  padding: 12px;
  transition: all 0.2s ease;

  &:hover {
    background: #F2F2F2;
    color: rgba(33, 33, 33, 1);
  }

  svg path {
    fill: currentColor;
  }

  input {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
  }
}

.frisbuy-iu__upload__button--disabled {
  opacity: 0.6;
  cursor: not-allowed;

  input {
    pointer-events: none;
  }
}

.frisbuy-iu__media-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.frisbuy-iu__media-item {
  position: relative;
  width: 88px;
  height: 88px;
  flex: 0 0 88px;
  border-radius: 6px;
  overflow: hidden;
  background: #efeff0;
}

.frisbuy-iu__media-add-tile {
  position: relative;
  width: 88px;
  height: 88px;
  flex: 0 0 88px;
  border: 0;
  border-radius: 8px;
  background: #f6f6f6;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    background: #f2f2f2;
    color: #212121;
  }

  svg path {
    fill: currentColor;
  }

  input {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
  }
}

.frisbuy-iu__media-add-tile--disabled {
  opacity: 0.6;
  cursor: not-allowed;

  input {
    pointer-events: none;
  }
}

.frisbuy-iu__media-image {
  width: 88px;
  height: 88px;
  object-fit: cover;
}

.frisbuy-iu__media-video-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 32px;
  height: 32px;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
}

.frisbuy-iu__media-close {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  cursor: pointer;
}


.frisbuy-iu__person-info {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
}

.frisbuy-iu__person-info > .frisbuy-iu__input-form {
  margin-top: 12px;
}

.frisbuy-iu__person-info > .frisbuy-iu__input-form:first-of-type {
  margin-top: 16px;
}

.frisbuy-iu__person-title {
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #212121;
}

.frisbuy-iu__controls {
  margin-top: 24px;
}

.frisbuy-iu__checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;

  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
  }
}

.frisbuy-iu__checkbox__toggle {
  position: relative;
  width: 24px;
  height: 24px;
  margin-top: -2px;
  flex: 0 0 24px;
}

.frisbuy-iu__checkbox__toggle--checked {
  .frisbuy-iu__checkbox-icon--off {
    opacity: 0;
    transform: scale(0.9);
  }

  .frisbuy-iu__checkbox-icon--on {
    opacity: 1;
    transform: scale(1);
  }
}

.frisbuy-iu__checkbox-icon {
  position: absolute;
  inset: 0;
  display: block;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.frisbuy-iu__checkbox-icon--off {
  opacity: 1;
  transform: scale(1);
}

.frisbuy-iu__checkbox-icon--on {
  opacity: 0;
  transform: scale(0.9);
}

.frisbuy-iu__checkbox__label {
  font-size: 14px;
  line-height: 24px;
  color: #666666;

  a {
    color: inherit;
    text-decoration: underline;
  }
}

.frisbuy-iu__field-error {
  display: block;
  margin-top: 6px;
  color: rgba(254, 0, 102, 1);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
}

.frisbuy-iu__media-error {
  margin-top: 8px;
}

.frisbuy-iu__submit {
  width: 100%;
  border: 0;
  border-radius: 999px;
  min-height: 44px;
  margin-top: 24px;
  background: rgba(0, 185, 191, 1);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  font-family: Gilroy, "Segoe UI", Arial, sans-serif;
  cursor: pointer;

  &:hover {
    background: rgba(23, 196, 201, 1);
  }
}

.frisbuy-iu__submit--disabled {
  opacity: 0.55;
  pointer-events: none;
}

.frisbuy-iu__submit-mobile-wrap {
  display: none;
}

.frisbuy-iu__message {
  padding: 10px 12px;
  border-radius: 8px;
  background: #ffe9ea;
  display: flex;
  gap: 8px;
  font-size: 12px;
}

.frisbuy-iu__message-congrats {
  background: #ebf7ef;
}

.frisbuy-iu__drop-area {
  position: absolute;
  inset: 8px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(16, 182, 189, 0.2);
}

.frisbuy-iu__drop-area--limited {
  background: rgba(199, 48, 48, 0.2);
}

.frisbuy-iu__stars-title {
  color: #212121;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}

@media (max-width: 1023px) {
  .frisbuy-iu__overlay {
    align-items: flex-start;
    padding: 80px 0 0;
  }

  .frisbuy-iu__popup {
    width: 100%;
    max-height: calc(100vh - 80px);
    height: calc(100vh - 80px);
    border-radius: 8px 8px 0 0;
  }

  .frisbuy-iu__header {
    padding: 0;
  }

  .frisbuy-iu__close {
    right: 0;
    top: 0;
  }

  .frisbuy-iu__popup-scroll {
    padding: 0 16px 88px;
  }

  .frisbuy-iu__title {
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
  }

  .frisbuy-iu__required,
  .frisbuy-iu__review-description,
  .frisbuy-iu__person-title,
  .frisbuy-iu__upload-title,
  .frisbuy-iu__stars-title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
  }

  .frisbuy-iu__post-form {
    margin-top: 24px;
  }

  .frisbuy-iu__person-note {
    display: none;
  }

  .frisbuy-iu__upload-section {
    display: none;
  }


  .frisbuy-iu__controls .frisbuy-iu__submit {
    display: none;
  }

  .frisbuy-iu__submit-mobile-wrap {
    display: block;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 64px;
    padding: 8px 16px 16px;
    box-sizing: border-box;
    background: #fff;
    z-index: 100000000000000;
  }

  .frisbuy-iu__submit--mobile {
    margin-top: 0;
    min-height: 40px;
  }
}
</style>
